// JavaScript source code
import React, { useState, useEffect, useRef } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import SubHeader from '../components/subheader';
import SubFooter from '../components/subfooter';
import LoginDialog from '../components/loginDialog';
import LoadingOverlay from '../components/loadingOverlay';
import MessageDialog from '../components/messageDialog';
import ConfirmDialog from '../components/confirmDialog';
import ChooseAddressDialog from '../components/chooseAddressDialog';
import { post,get, getUser, handleImageError, getCart, saveCart } from '../request';
import Button from '../components/button';
import config from '../config';
import dataFoot from '../assets/fake-data/data-foot';
function Confirmorder(props) {
    const activeIndex = 5;

    const [errorMessage, setErrorMessage] = useState("");
    var parentBusinessId = 0;
    const navigate = useNavigate();
    const [isShowLogin, setIsShowLogin] = useState(false);
    const [isLoading, setShowLoading] = useState(false);
    const [isShowConfirmDialog, setConfirmDialog] = useState(false);

    var user = getUser();
    const [item, setItem] = useState({});
    const [deliveryAddress, setDefaultAddress] = useState({});
    const [deliveryAddressList, setDefaultAddressList] = useState([]);
    const [cartlist, setCartlist] = useState([]);
    const [orderItems, setOrderItems] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);

    const [totalQuantity, setTotalQuantity] = useState(0);
    const [totalWeight, setTotalWeight] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0);
    const [totalPoint, setTotalPoint ]= useState(0);
    const [totalYear, setTotalYear] = useState(0);
    const [totalRun, setTotalRun] = useState(0);
    const [isShowModify, setIsShowModify] = useState(false);
    const [screenSize, setScreenSize] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => {
            setScreenSize(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        loadData();
    }, []);
    const loadData = () => {
        if (user == null || user.userType != 1) {
            setIsShowLogin(true);
            return;
            //history.goBack();
        }
        var theOrderItems = JSON.parse(localStorage.getItem('order-items'));
        var theSelectedItems = JSON.parse(localStorage.getItem('selectedItems'));
        setOrderItems(theOrderItems);
        setSelectedItems(theSelectedItems);

        getCart().then(function (response) {
            if (response.statusCode !== 200) {
                alert("请重新登录！");
                setIsShowLogin(true);
                return;
            }
            //setCartlist(response.items);
            if (theOrderItems) {
                setCartlist(convertList(theOrderItems.skus));
                localStorage.setItem('order-items', null);
            }
            else {
                setCartlist(convertList(theSelectedItems));
                //localStorage.setItem('selectedItems', null);
            }
        });


        get('delianapi/business/my').then((response) => {
            if (response.statusCode !== 200 || response.items.length == 0) {
                return;
            }
            var item = response.items[0];
            if (item.deliveryAddressList ) {
                setDefaultAddressList(item.deliveryAddressList);
                var defaultAddress = item.deliveryAddressList.filter(function (addr) {
                    return addr.isDefault;
                });
                if (defaultAddress.length > 0) {
                    setDefaultAddress(defaultAddress[0]);
                }
                else {
                    setDefaultAddress(item.deliveryAddressList[0]);
                }
            }          

            setItem( item);
            //setTimeout(function () {
            //    autoHeight = $(".address-list").css('height', 'auto').height();
            //    $(".address-list").css('height', '195px');

            //}, 0);
        });

    }
    function convertList(items) {
        var tPoint = totalPoint;
        var tPrice = totalPrice;
        var tYear = totalYear;
        var tRun = totalRun;
        items.forEach(function (cart) {
            if (!cart.sku.imageUrl ) {
                cart.sku.imageUrl = dataFoot.noimageSmall;
            }              

            cart.selected = true;
            setTotalQuantity(parseInt(totalQuantity) + parseInt(cart.sum));
            setTotalWeight( totalWeight + cart.sku.weight * cart.sum);

            if (!cart.pointsDeductionInput) cart.pointsDeductionInput = 0;
            if (cart.sku.isCanPoints) {
                tPoint = totalPoint + cart.pointsDeduction;
                if (cart.pointsDeductionInput) {
                    tPoint = tPoint - parseFloat(cart.pointsDeductionInput);
                    tPrice = tPrice + parseFloat(cart.pointsDeductionInput);
                }
            } else {
                tPrice = tPrice + cart.sum * cart.sku.servicePrice;
                if (cart.pointsDeductionInput) {
                    tPoint = tPoint+ parseFloat(cart.pointsDeductionInput);
                    tPrice = tPrice - parseFloat(cart.pointsDeductionInput);
                }
            }
            var parameter = cart.sku.parameter > 0 ? cart.sku.parameter : 1;
            var beishu = (cart.sum / parameter);
            cart.sku.yearIntegral = (user.business.businessType === 0 ? cart.sku.serviceYearIntegral : cart.sku.dealerYearIntegral) * beishu;
            cart.sku.runIntegral = (user.business.businessType === 0 ? cart.sku.serviceRunIntegral : cart.sku.dealerRunIntegral) * beishu;

            tYear += cart.sku.yearIntegral;
            tRun += cart.sku.runIntegral;
            var index = cart.sku.name.indexOf('（');
            if (index < 0) {
                index = cart.sku.name.indexOf('(');
            }
            if (index > 0) {
                cart.showName = cart.sku.name.substring(0, index);
            }
            else {
                cart.showName = cart.sku.name;
            }
            var skuList = cart.sku.skuName.split('|');
            cart.skuList = skuList.map(function (sku) {
                var s = sku.split(':');
                return { name: s[0], value: s[1] };
            });
        });

        setTotalPoint(tPoint);
        setTotalPrice(tPrice);
        setTotalYear(tYear);
        setTotalRun(tRun);

        return items;
    }
    const clearCart = ()=> {
        if (orderItems) {
            localStorage.setItem('order-items', null);
            navigate(config.root + '/Mydelian');
        }
        else if (selectedItems) {
            localStorage.setItem('selectedItems', null);
            selectedItems.forEach(function (cart) {
                saveCart(cart.skuId, 0);
                navigate(config.root + '/Mydelian');
            });
        }
        else {
            post('delianapi/product/deleteCartitem').then(function (response) {
                if (response.statusCode !== 200) {
                    setErrorMessage(response.message);
                    return;
                }
                navigate(config.root + '/Mydelian');
            });
        }

    }
    const order = ()=> {
        if (cartlist.length == 0) {
            setErrorMessage("明细不能为空！");
            return;
        }
        if (!deliveryAddress) {
            setErrorMessage("请先选择收货地址！");
            return;
        }
        setConfirmDialog(true);
    }
    const confirmOrder = () => {
        setConfirmDialog(false);
        var orderItem = {
            id: 0,//新订单为0
            name: 'web端新增的订单',//没用
            recordNO: 'code',//系统自动生成
            orderStatus: 0,//新增为0
            business: null,//由登录信息获得
            customer: null,//由登录信息获得
            businessId: 0,//由登录信息获得
            BusinessType: 0,//由登录信息获得
            remark: 'web端新增的订单',
            totalPrice: totalPrice,
            orderDate: '1900-01-01',//系统自动生成
            salesman: null,//为空
            creatorUser: null,//由登录信息获得
            creatorBusiness: null,//由登录信息获得
            //发票信息
            invoiceType: 0,
            invoiceTitle: '',
            offPeriodType: 2,
            offPeriodDays: 0,
            //收货地址
            deliveryAddressId: deliveryAddress.id,
            deliveryAddress: '',//系统根据deliveryAddressId自动生成
            deliveryZipcode: '',//系统根据deliveryAddressId自动生成
            contactName: '',//系统根据deliveryAddressId自动生成
            contactPhone: '',//系统根据deliveryAddressId自动生成
            deliveryType: 0,
            deliveryDate: '',
            remark: item.remark,
            //产品
            orderProductList: []
        };
        for (var i = 0; i < cartlist.length; i++) {
            var skutemp = cartlist[i];
            //使用积分
            var pointsDeduction = skutemp.sku.isCanPoints ? skutemp.sku.servicePrice * skutemp.sum - skutemp.pointsDeductionInput : skutemp.pointsDeductionInput;
            //单价根据积分使用情况计算
            var price = skutemp.sku.isCanPoints ? (skutemp.pointsDeductionInput / skutemp.sum).toFixed(4) : ((skutemp.sku.servicePrice * skutemp.sum - skutemp.pointsDeductionInput) / skutemp.sum).toFixed(4);
            var orderproduct = {
                productSKU: skutemp.sku,
                name: skutemp.sku.name,
                price: price,
                originalPrice: skutemp.sku.isPromotion ? skutemp.sku.promotionPrevPrice : skutemp.sku.servicePrice,
                quantity: skutemp.sum,
                remark: pointsDeduction > 0 ? '使用积分兑换' : '',
                pointsDeduction: pointsDeduction,
                isCanPoints: skutemp.sku.isCanPoints
            };
            orderItem.orderProductList.push(orderproduct);
        }
        setShowLoading(true);
        post('delianapi/order/weborder', orderItem).then(function (response) {
            setShowLoading(false);
            if (response.statusCode == 200) {
                setErrorMessage('下单完成');
                clearCart();
            } else {
                setErrorMessage(response.message);
            }
        });
    }
    const finishLogin = () => {
        setIsShowLogin(false);
        //navigate("/JoinUsStep");
        user = getUser();
    }
    const modifyClick = () => {
        setIsShowModify(true);

    }
    const finishModify = (item) => {
        setDefaultAddress(item);
        setIsShowModify(false);
    }
    const closeModify = () => {
        setIsShowModify(false);
    }

    const handleLocalImageError = (productId, type = 'small') => {
        // 调用公共的handleImageError函数  
        handleImageError(setErrorState, type, productId);
    };
    const setErrorState = (productId, defaultImageUrl) => {
        const oldlist = [...cartlist];
        oldlist.forEach(function (item) {
            if (item.skuId == productId) {
                item.sku.imageUrl = defaultImageUrl;
                item.error = true;
            }
        });
        setCartlist(oldlist);
    };

    return (
        <div className="cartlist Confirmorder" >
            <SubHeader activeIndex={activeIndex} user={user} setIsShowLogin={setIsShowLogin}/>
            <div className="content">
                <div className="title">
                    确认订单                   
                </div>
                <div className="cartlistDiv" >
                    <div className="contactName" >
                        {deliveryAddress.contactName + ' ' + deliveryAddress.mobilePhone}                       
                        {
                            deliveryAddress.isDefault &&
                            <div className="default"> 默认地址</div>
                        }
                        <div className="modify" onClick={modifyClick} >修改地址</div>
                    </div>
                    <div className="contactDetail"> {
                        (deliveryAddress.provinceName || '') + ' ' + (deliveryAddress.cityName || '')
                        + ' ' + (deliveryAddress.districtName || '') + ' ' + deliveryAddress.address + ' '
                        + deliveryAddress.zipCode
                    }
                    </div>
                    {
                        cartlist.map((cart, index) => (
                            screenSize > 991 ? (
                                <div className="tr" key={`cart-${cart.skuId}`}>
                                    <div>
                                        <img className="cart-image" onError={() => handleLocalImageError(cart.skuId, 'small')}
                                            src={cart.sku.imageUrl} alt=" " />
                                    </div>
                                    <div className="productName">
                                        <div className="showName">{cart.showName}</div>
                                        <div className="code">{cart.sku.code}</div>

                                    </div>
                                    <div>
                                        {
                                            cart.skuList.map((sku, index) => (
                                                <div key={`sku-${index}`}>
                                                    <span > {sku.name}</span>
                                                    <span > {sku.value}</span>
                                                </div>
                                            ))
                                        }
                                    </div>
                                    <div className="fs-12 fw-600">
                                        <span className={cart.sku.isCanPoints ? 'blue' : 'red'}>
                                            <small >{cart.sku.isCanPoints ? '积分' : '￥'}</small>
                                            <span className="fs-14" >{cart.sku.servicePrice} </span>
                                        </span>
                                        <span className="fs-14" > × {cart.sum}</span>
                                    </div>
                                    <div>
                                        <span >总重量：</span>
                                        <span >{(cart.sku.weight * cart.sum).toFixed(2)}</span> kg

                                    </div>
                                    <div>
                                        {
                                            !cart.sku.isCanPoints &&
                                            <div className="red fw-600" >
                                                <small>￥</small>
                                                <span className="fs-14" >
                                                    {(cart.sku.servicePrice * cart.sum).toFixed(2)}</span>
                                            </div>
                                        }
                                        {
                                            cart.sku.isCanPoints &&
                                            <div className="blue" >
                                                <small>积分</small>
                                                <span className="fs-24" >{(cart.pointsDeduction).toFixed(2)}</span>
                                            </div>
                                        }

                                    </div>

                                </div>
                                ):(
                                    <div className="tr" key={`cart-${cart.skuId}`}>
                                        <div>
                                            <img className="cart-image" onError={() => handleLocalImageError(cart.skuId, 'small')}
                                                src={cart.sku.imageUrl} alt=" " />
                                        </div>
                                        <div className="productName">
                                            <div className="showName">{cart.showName}</div>
                                            <div className="code">{cart.sku.code}</div>
                                            <div className="fs-12 fw-600 price-sum">
                                                <span className={cart.sku.isCanPoints ? 'blue' : 'red'}>
                                                    <small >{cart.sku.isCanPoints ? '积分' : '￥'}</small>
                                                    <span className="fs-14" >{cart.sku.servicePrice} </span>
                                                </span>
                                                <span className="fs-14" > × {cart.sum}</span>
                                            </div>
                                            <div className ="sku-weight">
                                                {
                                                    cart.skuList.map((sku, index) => (
                                                        <div key={`sku-${index}`}>
                                                            <span > {sku.name}</span>
                                                            <span > {sku.value}</span>
                                                        </div>
                                                    ))
                                                }
                                                <div>
                                                    <span >总重量：</span>
                                                    <span >{(cart.sku.weight * cart.sum).toFixed(2)}</span> kg

                                                </div>
                                            </div>
                                            <div>
                                                {
                                                    !cart.sku.isCanPoints &&
                                                    <div className="red fw-600" >
                                                        <small>￥</small>
                                                        <span className="fs-14" >
                                                            {(cart.sku.servicePrice * cart.sum).toFixed(2)}</span>
                                                    </div>
                                                }
                                                {
                                                    cart.sku.isCanPoints &&
                                                    <div className="blue" >
                                                        <small>积分</small>
                                                        <span className="fs-24" >{(cart.pointsDeduction).toFixed(2)}</span>
                                                    </div>
                                                }

                                            </div>
                                        </div>
                                    </div> )
                           
                        ))
                    }
                    <div className="address-list remark">
                        <label>订单备注：</label>
                        <textarea className="form-control" 
                            title="选填：对于该订单的额外备注说明,最多输入500个字符"
                            autoComplete="off"
                            placeholder="选填：对本次交易的说明（建议填写已经和卖家达成一致的说明）,最多输入500个字符"
                            maxLength="500">
                            {item.remark}
                        </textarea>
                    </div>
                    <div className="heji confirm">
                        <div className="content">

                            <div className="right-content" >
                                <div className="flex-between"><div >
                                    已选商品 <span className="red" >{totalQuantity}</span> 件 </div>
                                    <div >
                                <span className="totleprice-label">总金额：</span>
                                
                                <span className="red">￥
                                    <span className="fs-32 totleprice fw-600" >{totalPrice.toFixed(2)}</span></span>
                                {
                                    totalPoint > 0 &&
                                    <span className="blue" > + 积分
                                        <span className="fs-32 totleprice" >{totalPoint.toFixed(2)}</span></span>

                                        }
                                    </div>
                                </div>
                                <Button onClick={order}
                                    btnclass={`btn  jiesuan fs-25 `} title="结  算" />

                            </div>
                        </div>
                    </div>
                </div>

            </div>
           
            <SubFooter />
            <LoginDialog isShowLogin={isShowLogin} onCancel={finishLogin} />
            <MessageDialog message={errorMessage} onCancel={() => {
                setErrorMessage("");
            }} />
            <LoadingOverlay isLoading={isLoading}>
            </LoadingOverlay>
            <ConfirmDialog isShowConfirmDialog={isShowConfirmDialog}
                message="确认下单后，该订单不能再修改，确认该操作吗？"
                onConfirm={confirmOrder}
                onCancel={() => { setConfirmDialog(false) }}
            />
            <ChooseAddressDialog isShow={isShowModify} onConfirm={finishModify} onCancel={closeModify}
                initItem={deliveryAddress} list={deliveryAddressList}/>
        </div>

    );
}

export default Confirmorder;